import { PROGRAM_TYPES } from 'site-modules/shared/components/incentives/incentives-wizard/constants/program-types';

export function isOEMRebate(incentive) {
  const { programType, primary, compatibleIncentiveIds } = incentive;
  return (
    ![PROGRAM_TYPES.TAX_CREDIT, PROGRAM_TYPES.EV_REBATE, PROGRAM_TYPES.CHARGER_INSTALLATION].includes(programType) &&
    (primary || (compatibleIncentiveIds?.length === 0 && programType === PROGRAM_TYPES.EV_CHARGING))
  );
}
